module.exports = __webpack_public_path__ + "static/img/search-bg-default.a46e79c.png";


//////////////////
// WEBPACK FOOTER
// ./static/ugc/list/search-bg-default.png
// module id = ocN4
// module chunks = 1